import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel, ConstructionOutlined } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { toast } from 'react-toastify';
import { useCallback } from 'react';
import useFetchData from 'hooks/useFetchData';

import { useTranslation } from "react-i18next";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const columns = [
    { id: 'id', label: '#', minWidth: 30 },
    { id: 'imageUrl', label: 'Image', minWidth: 80, type: 'image' },
    { id: 'name', label: '名字', minWidth: 120 },
    { id: 'taskValue', label: '价格', minWidth: 120 },
    // { id: 'profit', label: 'Profit', minWidth: 120 },
    // { id: 'commission', label: 'Commission', minWidth: 30 },
    { id: 'code', label: '编号', minWidth: 120 }
];

const TasklistRecord = () => {
    const { t } = useTranslation();

    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();

    const [tasklist, setTasklist] = useState([]);
    const [tasklistCount, setTasklistCount] = useState(0);
    const [filterTaskName, setFilterTaskName] = useState('');
    const [filterTaskValueRangeStart, setFilterTaskValueRangeStart] = useState(0);
    const [filterTaskValueRangeEnd, setFilterTaskValueRangeEnd] = useState(0);
    const [customerNameOptions, setCustomerNameOptions] = useState([]);

    const [isLoading, setLoading] = useState(true);
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [prevPages, setPrevPages] = useState([]);
    const [newPage, setNewPage] = useState(0);

    // const { data: allTasklistCategories } = useFetchData('/TasklistCategories/All');
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // const handleChangePage = (event, currentNewPage) => {
    //     // Check if newPage is greater than or equal to the current page
    //     if (currentNewPage >= page) {
    //         // Set the page state
    //         setPage(currentNewPage);

    //         // Check if the new page is not in the list of previously fetched pages
    //         if (!prevPages.includes(currentNewPage)) {
    //             // If it's not, add it to the list and fetch the data
    //             setPrevPages((prevPages) => [...prevPages, currentNewPage]);
    //             setNewPage(currentNewPage); // Update the newPage state
    //         }
    //     } else {
    //         // If newPage is less than the current page, just set the page state without fetching new data
    //         setPage(currentNewPage);
    //     }
    //     console.log('22222 page', page);
    //     fetchTasklistRecord(currentNewPage, rowsPerPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(event.target.value);
    //     console.log('11111 rowsPerPage', rowsPerPage);
    //     fetchTasklistRecord(page, event.target.value);
    // };

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    //fetch sales start
    const [fetchTasklistLoading, setFetchTasklistLoading] = useState(false);
    const fetchTasklistRecord = async (currentPage, currentRowsPerPage) => {
        let tasklistRecordURL = `/Tasklist/All`;
        let tasklistRecordCountURL = `/Tasklist/TotalCount`;

        let params = '';
        let hasParam = false;
        // let params = `?pageIndex=${currentPage}&pageSize=${currentRowsPerPage}`;
        if (filterTaskName !== '') {
            params += `name=${filterTaskName}`;
            hasParam = true;
        }
        if (filterTaskValueRangeStart !== 0) {
            if (hasParam){
                params += '&';
            }
            params += `taskValueRangeStart=${filterTaskValueRangeStart}`;
            hasParam = true;
        }
        if (filterTaskValueRangeEnd !== 0) {
            if (hasParam){
                params += '&';
            }
            params += `taskValueRangeEnd=${filterTaskValueRangeEnd}`;
            hasParam = true;
        }
        
        if (hasParam)
        {
            tasklistRecordURL += '?';
            tasklistRecordCountURL += '?';
        }
        tasklistRecordURL += params;
        tasklistRecordCountURL += params;

        setFetchTasklistLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(tasklistRecordURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setTasklist(res.data);
                console.log('test result', tasklist.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
            } else {
                errorAlert('Something went wrong.');
            }
            
            const countRes = await axiosInstance.get(tasklistRecordCountURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (countRes.status === 200) {
                setTasklistCount(countRes.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFilterBtnDisabled(false);
            setFetchTasklistLoading(false);
        }
    };

    // With Promise All
    useEffect(() => {
        setLoading(true); // Set loading to true before starting the fetches

        // Define an array of async functions to fetch data
        const fetchFunctions = [fetchTasklistRecord(page, rowsPerPage)];
        // const fetchFunctions = [];

        // Use Promise.all to wait for all fetches to complete
        Promise.all(fetchFunctions)
            .then(() => {
                setLoading(false); // Set loading to false after all fetches are done
            })
            .catch((error) => {
                // Handle any errors that occurred during fetching
                console.error('Error fetching data:', error);
                setLoading(false); // Set loading to false even if there was an error
            });
    }, []);

    //sales table start
    function StickyHeadTable() {
        // const [page, setPage] = useState(0);
        // const [rowsPerPage, setRowsPerPage] = useState(100);

        // const handleChangePage = (event, newPage) => {
        //     setPage(newPage);
        // };

        // const handleChangeRowsPerPage = (event) => {
        //     setRowsPerPage(+event.target.value);
        //     setPage(0);
        // };

        return (
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
                <TableContainer sx={{ height: '100vh' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key="id" style={{ minWidth: 30 }}>#</TableCell>
                                <TableCell key="imageUrl" style={{ minWidth: 80 }}>{t("tasklist.image")}</TableCell>
                                <TableCell key="name" style={{ minWidth: 120 }}>{t("tasklist.taskName")}</TableCell>
                                <TableCell key="taskValue" style={{ minWidth: 120 }}>{t("tasklist.taskPrice")}</TableCell>
                                <TableCell key="code" style={{ minWidth: 120 }}>{t("tasklist.code")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                            tasklist.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (column.type && column.type === 'date') {
                                                if (value) {
                                                    const timeString12hr = new Date(
                                                        '1970-01-01T' + value.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    });
                                                    value = `${value.split('T')[0]} ${timeString12hr}`;
                                                }
                                            }
                                            if (column.type && column.type === 'image') {
                                                if (value) {
                                                    return (
                                                        <TableCell key={column.id} align={column.align}>
                                                            <img alt={value} src={`${value}?v=${new Date().getTime()}`} width={column.minWidth} />
                                                            {/* <img alt={value} src={value} width={column.minWidth} /> */}
                                                        </TableCell>
                                                    );
                                                }
                                            }
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                <UpdateTasklistRecord tasklist={row} />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={tasklistCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
    //sales table end

    const InsertTasklistRecord = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [updateTaskName, setUpdateTaskName] = useState('');
        const [updateTaskValue, setUpdateTaskValue] = useState(0);
        const [updateTaskCommission, setUpdateTaskCommission] = useState(0);
        const [updateTaskCode, setUpdateTaskCode] = useState('');
        const [updateTaskCategoryID, setUpdateTaskCategoryID] = useState(0);
        const [image, setImage] = useState(new FormData());
        const [previewImage, setPreviewImage] = useState('');

        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
        const [insertTasklistLoading, setInsertTasklistLoading] = useState(false);

        const addImage = async (taskID) => {
            setInsertBtnDisabled(true);
            setTimeout(() => {
                setInsertBtnDisabled(false);
            }, 3000);
            setInsertTasklistLoading(true);
            try {
                const res = await axiosInstance.post(
                    '/Tasklist/Image?taskID=' + taskID,
                    image,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Tasklist inserted successfully.');
                    fetchTasklistRecord(page, rowsPerPage);
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertTasklistLoading(false);
            }
        }
        
        const handleImageChange = async (e) => {
            e.preventDefault();
            let form = new FormData();
            for (var index = 0; index < e.target.files.length; index++) {
                var element = e.target.files[index];
                form.append('image', element);
            }
            form.append('fileName', "Img");
            setImage(form);
            setPreviewImage(URL.createObjectURL(event.target.files[0]));
            //this.setState({ file: form });
        };

        //fetch Non Payment Date end
        const submitInsertTasklist = async () => {
            setInsertBtnDisabled(true);
            setTimeout(() => {
                setInsertBtnDisabled(false);
            }, 3000);
            setInsertTasklistLoading(true);
            try {
                const res = await axiosInstance.post(
                    '/Tasklist',
                    {
                        name: updateTaskName,
                        taskValue: parseFloat(updateTaskValue),
                        commission: parseFloat(updateTaskCommission),
                        code: updateTaskCode
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    addImage(res.data);
                    // successAlert('Tasklist inserted successfully.');
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertTasklistLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    {t("tasklist.createTask")}
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {insertTasklistLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    {t("tasklist.createTask")}
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '450px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("tasklist.taskName")} :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateTaskName}
                                                onChange={(e) => setUpdateTaskName(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("tasklist.taskPrice")} :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateTaskValue}
                                                onChange={(e) => setUpdateTaskValue(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    
                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Commission Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '20%', height: '50px', borderRadius: '10px' }}
                                                value={updateTaskCommission }
                                                onChange={(e) => setUpdateTaskCommission(e.target.value)}
                                            />
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                %
                                            </Typography>
                                        </Box>
                                    </Grid> */}

                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Task Code :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateTaskCode}
                                                onChange={(e) => setUpdateTaskCode(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                商品类别 :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateTaskCategoryID}
                                                onChange={(e) => setUpdateTaskCategoryID(e.target.value)}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value={0}>
                                                    请选择一个商品类别...
                                                </MenuItem>
                                                {allTasklistCategories.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid> */}
                                                                
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("tasklist.image")} : 
                                            </Typography>
                                            <p>
                                                <input name="Avatar" id='img' type="file" class="form-control" onChange={(e) => handleImageChange(e)}/>
                                            </p>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div className="imgPreview">
                                                <img alt='Task' width='120' src={previewImage}/>
                                            </div>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertTasklist()}
                                disabled={insertBtnDisabled}
                            >
                                {t("tasklist.createTask")}
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };

    const UpdateTasklistRecord = ({ tasklist }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const [updateTaskName, setUpdateTaskName] = useState(tasklist.name ? tasklist.name : '');
        const [updateTaskValue, setUpdateTaskValue] = useState(tasklist.taskValue);
        const [updateTaskCommission, setUpdateTaskCommission] = useState(tasklist.commission);
        const [updateTaskCode, setUpdateTaskCode] = useState(tasklist.code ? tasklist.code : '');
        const [updateTaskCategoryID, setUpdateTaskCategoryID] = useState(tasklist.categoryID ? tasklist.categoryID : '');
        const [image, setImage] = useState(new FormData());

        const [previewImage, setPreviewImage] = useState(tasklist.imageUrl ? tasklist.imageUrl : '');

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updateTasklistLoading, setUpdateTasklistLoading] = useState(false);

        const isFormDataEmpty = (formData) => {
            for (let pair of formData.entries()) {
                return false; // Found at least one entry
            }
            return true; // No entries found
        };
          
        const updateImage = async (taskID) => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            setUpdateTasklistLoading(true);
            try {
                const res = await axiosInstance.post(
                    '/Tasklist/Image?taskID=' + taskID,
                    image,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Tasklist updated successfully.');
                    fetchTasklistRecord(page, rowsPerPage);
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                // setUpdateTasklistLoading(false);
            }
        }
        
        const handleImageChange = async (e) => {
            e.preventDefault();
            let form = new FormData();
            for (var index = 0; index < e.target.files.length; index++) {
                var element = e.target.files[index];
                form.append('image', element);
            }
            form.append('fileName', "Img");
            setImage(form);
            setPreviewImage(URL.createObjectURL(event.target.files[0]));
            //this.setState({ file: form });
        };

        //fetch Non Payment Date end
        const submitUpdateTasklist = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);
            setUpdateTasklistLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/Tasklist',
                    {
                        id: tasklist.id,
                        name: updateTaskName,
                        taskValue: parseFloat(updateTaskValue),
                        commission: parseFloat(updateTaskCommission),
                        code: updateTaskCode
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    if (isFormDataEmpty(image)){
                        successAlert('Tasklist updated successfully.');
                    }
                    else{
                        updateImage(tasklist.id);
                    }
                    
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateTasklistLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updateTasklistLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    {t("tasklist.updateTask")}
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '450px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("tasklist.taskName")} :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateTaskName}
                                                onChange={(e) => setUpdateTaskName(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("tasklist.taskPrice")} :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateTaskValue}
                                                onChange={(e) => setUpdateTaskValue(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    
                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Commission Percentage :
                                            </Typography>
                                            <input
                                                type="number"
                                                style={{ width: '20%', height: '50px', borderRadius: '10px' }}
                                                value={updateTaskCommission }
                                                onChange={(e) => setUpdateTaskCommission(e.target.value)}
                                            />
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                %
                                            </Typography>
                                        </Box>
                                    </Grid> */}

                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Task Code :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={updateTaskCode}
                                                onChange={(e) => setUpdateTaskCode(e.target.value)}
                                            />
                                        </Box>
                                    </Grid> */}

                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                商品类别 :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateTaskCategoryID}
                                                onChange={(e) => setUpdateTaskCategoryID(e.target.value)}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value={0}>
                                                    请选择一个商品类别...
                                                </MenuItem>
                                                {allTasklistCategories.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid> */}

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("tasklist.image")} : 
                                            </Typography>
                                            <p>
                                                <input name="Avatar" id='img' type="file" class="form-control" onChange={(e) => handleImageChange(e)}/>
                                            </p>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div className="imgPreview">
                                                <img alt='Task' width='120 ' src={previewImage}/>
                                            </div>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdateTasklist()}
                                disabled={updateBtnDisabled}
                            >
                                {t("tasklist.update")}
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };

    return (
        <Grid container item xs={12} padding="20px">
            <InsertTasklistRecord />
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("tasklist.taskName")} : 
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            value={filterTaskName}
                            onChange={(e) => setFilterTaskName(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {t("tasklist.taskPrice")} : 
                        </Typography>
                        <TextField
                            type='number'
                            id="outlined-basic"
                            variant="outlined"
                            value={filterTaskValueRangeStart}
                            onChange={(e) => setFilterTaskValueRangeStart(e.target.value)}
                        />
                        -
                        <TextField
                            type='number'
                            id="outlined-basic"
                            variant="outlined"
                            value={filterTaskValueRangeEnd}
                            onChange={(e) => setFilterTaskValueRangeEnd(e.target.value)}
                        />
                    </Box>
                </Grid>
                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Task Value Range End : 
                        </Typography>
                    </Box>
                </Grid> */}
                <Grid item container xs={12} md={12} lg={12}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '30px'
                        }}
                        onClick={() => fetchTasklistRecord(page, rowsPerPage)}
                        disabled={filterBtnDisabled}
                    >
                        {t("tasklist.filter")}
                    </Button>
                </Grid>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {fetchTasklistLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default TasklistRecord;